import { render, staticRenderFns } from "./date-is-today.vue?vue&type=template&id=d3cad846&scoped=true"
import script from "./date-is-today.vue?vue&type=script&lang=js"
export * from "./date-is-today.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cad846",
  null
  
)

export default component.exports